
module.exports = {
    NODE_ENV: "production",
    BASE_URL: 'https://www.cstr.cn/openapi/v3/',
}